import React from 'react';

export default function item(props) {
    return (
        <a href={props.detailsUrl} className="c-clubnews__club">
            <div className="c-clubnews__title">{props.title}</div>
            <div className="c-clubnews__subtitle">{props.date}</div>
        </a>
    )
}
